import WorkflowAnimatedHelpEdge from './WorkflowAnimatedHelpEdge';
import WorkflowBranchEdge from './WorkflowBranchEdge';
import WorkflowEdge from './WorkflowEdge';
import WorkflowInvisibleEdge from './WorkflowInvisibleEdge';
import WorkflowLoopConnectorEdge from './WorkflowLoopConnectorEdge';
import { EdgeTypes } from '@/components/FlowTree/flow-tree-service.const';
export {
	Y_AXIS_SPACER,
	BORDER_RADIUS,
	PLUS_BUTTON_SIZE,
	CONSOLIDATE_NODE_HEIGHT,
} from '@/react_app/components/ReactFlow/EdgeTypes/edge.const';

export const EDGE_TYPE_COMPONENT_MAP = {
	[EdgeTypes.Next]: WorkflowEdge,
	[EdgeTypes.Diverge]: WorkflowBranchEdge,
	[EdgeTypes.Invisible]: WorkflowInvisibleEdge,
	[EdgeTypes.ConsolidatedBy]: WorkflowInvisibleEdge,
	[EdgeTypes.LoopConnector]: WorkflowLoopConnectorEdge,
	[EdgeTypes.AnimatedHelpEdge]: WorkflowAnimatedHelpEdge,
};

export { EdgePlusButton } from './EdgePlusButton';
